/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';

import AuthGuard from './components/AuthGuard';

import AuthLayout from './layouts/Auth';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';
import DashboardAnalyticsView from './views/DashboardAnalytics';
import DashboardDefaultView from './views/DashboardDefault';
import OverviewView from './views/Overview';
import Home from './views/Home';
import PresentationView from './views/Presentation';
import Users from './views/Management/components/Users';
import Operators from './views/Management/components/Operators';
import OperatorDetails from './views/Management/components/OperatorDetails';
import Settings from './views/Management/components/Settings';
import DashboardInspect from './views/Dashboard/components/Inspect/DashboardInspect.js';
import Import from './views/Tracker/components/Import';
import Failures from './views/Tracker/components/Failures';
import FailuresMap from './views/FailuresMap/components/FailuresMap';
import Algorithms from './views/Algorithms/components/Algorithms';
import RepositoryExcel from './views/RepositoryExcel/components/RepositoryExcel';
import Repository from './views/RepositoryPdf/components/RepositoryPdf';
import OptSiteTracker from './views/OptimizationsSiteTracker/components/OptSiteTracker';
import OptOverallTracker from './views/OptimizationsOverallTracker/components/OptOverallTracker';

const routes = [
	{
		path: '/',
		exact: true,
		component: () => <Redirect to="/home" />,
	},
	{
		path: '/home',
		exact: true,
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			// projects: ['Operations'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '*',
								exact: true,
								component: (props) => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 1 } }, pageTitle: 'Home', module: 'Home' })
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}),
		}),
	},
	{
		path: '/modules',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/modules/import',
								exact: true,
								component: () => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: Import()
								}),
							},
							{
								path: '/modules/failures',
								exact: true,
								component: () => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: Failures()
								}),
							},
							{
								path: '/modules/map',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: FailuresMap()
								}),
							},
							{
								path: '/modules/algorithms',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: Algorithms()
								}),
							},
							{
								path: '/modules/repositoryPdf',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: Repository()
								}),
							},
							{
								path: '/modules/repositoryExcel',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: RepositoryExcel()
								}),
							},
							{
								path: '/modules/optSiteTracker',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: OptSiteTracker()
								}),
							},
							{
								path: '/modules/optOverallTracker',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: OptOverallTracker()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/dashboards',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/dashboards/inspect/:id',
								exact: true,
								component: (props) => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect(props)
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/management',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/management/operators',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: Operators()
								}),
							},
							{
								path: '/management/operators/details',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: OperatorDetails()
								}),
							},
							{
								path: '/management/users',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: Users(),
								}),
							},
							{
								path: '/management/statistics',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 2 } }, pageTitle: 'Statistics', module: 'Management' })
								}),
							},
							{
								path: '/management/settings',
								exact: true,
								component: () => AuthGuard({
									children: Settings()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),

	},
	{
		path: '/auth',
		component: AuthLayout,
		routes: [
			{
				path: '/auth/login',
				exact: true,
				component: lazy(() => import('views/Auth/Login')),
			},
			{
				path: '/auth/completeregistration',
				exact: true,
				component: lazy(() => import('views/Auth/CompleteRegistration')),
			},
			{
				path: '/auth/resetpassword',
				exact: true,
				component: lazy(() => import('views/Auth/ResetPassword')),
			},
			{
				path: '/auth/recover',
				exact: true,
				component: lazy(() => import('views/Auth/Recover')),
			},
			{
				path: '/auth/recoverconfirmation',
				exact: true,
				component: lazy(() => import('views/Auth/RecoverConfirmation')),
			},
			{
				component: () => <Redirect to="/errors/error-404" />,
			},
		],
	},

	{
		path: '/errors',
		component: ErrorLayout,
		routes: [
			{
				path: '/errors/error-401',
				exact: true,
				component: lazy(() => import('views/Error401')),
			},
			{
				path: '/errors/error-404',
				exact: true,
				component: lazy(() => import('views/Error404')),
			},
			{
				path: '/errors/error-500',
				exact: true,
				component: lazy(() => import('views/Error500')),
			},
			{
				component: () => <Redirect to="/errors/error-404" />,
			},
		],
	},
	{
		path: '*',
		component: () => AuthGuard({
			roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout({
				route: {
					routes: [
						{
							path: '/notifications',
							exact: true,
							component: lazy(() => import('views/Notifications')),
						},
						{
							path: '/calendar',
							exact: true,
							component: lazy(() => import('views/Calendar')),
						},
						{
							path: '/changelog',
							exact: true,
							component: lazy(() => import('views/Changelog')),
						},
						{
							path: '/chat',
							exact: true,
							component: lazy(() => import('views/Chat')),
						},
						{
							path: '/chat/:id',
							exact: true,
							component: lazy(() => import('views/Chat')),
						},
						{
							path: '/dashboard/analytics',
							exact: true,
							component: DashboardAnalyticsView,
						},
						{
							path: '/dashboard/default',
							exact: true,
							component: DashboardDefaultView,
						},
						{
							path: '/invoices/:id',
							exact: true,
							component: lazy(() => import('views/InvoiceDetails')),
						},
						{
							path: '/kanban-board',
							exact: true,
							component: lazy(() => import('views/KanbanBoard')),
						},
						{
							path: '/mail',
							exact: true,
							component: lazy(() => import('views/Mail')),
						},
						{
							path: '/manage/customers',
							exact: true,
							component: lazy(() => import('views/CustomerManagementList')),
						},
						{
							path: '/manage/customers/:id',
							exact: true,
							component: lazy(() => import('views/CustomerManagementDetails')
							),
						},
						{
							path: '/manage/customers/:id/:tab',
							exact: true,
							component: lazy(() => import('views/CustomerManagementDetails')
							),
						},
						{
							path: '/manage/projects',
							exact: true,
							component: lazy(() => import('views/ProjectManagementList')),
						},
						{
							path: '/manage/orders',
							exact: true,
							component: lazy(() => import('views/OrderManagementList')),
						},
						{
							path: '/manage/orders/:id',
							exact: true,
							component: lazy(() => import('views/OrderManagementDetails')),
						},
						{
							path: '/overview',
							exact: true,
							component: OverviewView,
						},
						{
							path: '/presentation',
							exact: true,
							component: PresentationView,
						},
						{
							path: '/profile/:id',
							exact: true,
							component: lazy(() => import('views/Profile')),
						},
						{
							path: '/profile/:id/:tab',
							exact: true,
							component: lazy(() => import('views/Profile')),
						},
						{
							path: '/projects/create',
							exact: true,
							component: lazy(() => import('views/ProjectCreate')),
						},
						{
							path: '/projects/:id',
							exact: true,
							component: lazy(() => import('views/ProjectDetails')),
						},
						{
							path: '/projects/:id/:tab',
							exact: true,
							component: lazy(() => import('views/ProjectDetails')),
						},
						{
							path: '/projects',
							exact: true,
							component: lazy(() => import('views/ProjectList')),
						},
						{
							path: '/settings',
							exact: true,
							component: lazy(() => import('views/Settings')),
						},
						{
							path: '/settings/:tab',
							exact: true,
							component: lazy(() => import('views/Settings')),
						},
						{
							path: '/social-feed',
							exact: true,
							component: lazy(() => import('views/SocialFeed')),
						},
						{
							path: '/getting-started',
							exact: true,
							component: lazy(() => import('views/GettingStarted')),
						},
						{
							component: () => <Redirect to="/errors/error-404" />,
						},
					],
				},
			})
		}),
	},
];

export default routes;
